module.exports = __webpack_public_path__ + "static/media/SearchIcoDuckDuckGo.bbb07731.png";